const Product = {
    case: "case",
    grip: "grip",
    wallet: "wallet",
    
    deviceID: null,
    device: null,

    hasOverlay(prod) {
        const productsWithOverlay = ["grip", "wallet"];
        return productsWithOverlay.includes(prod);
    }
};

export { Product };
